export default {
    /* Global Vocabulary */
    error_saving_data: 'Error saving data!',
    name: 'Name',
    first_name: 'First name',
    middle_name: 'Middle name',
    last_name: 'Last name',
    fullname: 'Full name',
    gender: 'Gender',
    man: 'Man',
    save: 'Save',
    woman: 'Woman',
    documents: 'Documents',
    start_typing_the_address: 'Start typing the address...',
    start_typing_new_address: 'Start typing new address...',
    male: 'Male',
    female: 'Female',
    other: 'Other',
    terms_conditions: 'TERMS & CONDITIONS',
    contact_number: 'Contact Number',
    preferences: 'Preferences',
    type: 'Type',
    type_here: 'Type here',
    new_address: 'New address',
    submit: 'Submit',
    language: 'Language',
    mobile_notifications: 'Mobile notifications',
    email_notifications: 'Email notifications',
    address_proof: 'Address proof',
    send_file_s: 'Send file(s)',

    /* Module special vocabulary */
    users: {
        menu: {
            index: 'Users',
            create: 'New',
            list: 'Users',
            profile: 'Profile',
            account: 'Account',
            rewards: 'Rewards',
        },
        table_titles: {
            id: 'ID',
            gender: 'Gender',
            first_name: 'First name',
            middle_name: 'Middle name',
            last_name: 'Last name',
            date_of_birth: 'Date of birth',
            introducer: 'Introducer',
            mobile: 'Mobile',
            country: 'Country',
            email: 'Email',
            address: 'Address',
            verify_identity: 'Verify Identity',
            account_type: 'Account type',
            ecdd: 'ECDD',
            is_blocked: 'Blocked',
            notes: 'Notes',
            acl: 'Access Level',
            email_verification_status: 'Email verification status',
            registered_at: 'Registered at',
            last_login_at: 'Last login',
            setting: 'Settings',
        },
        refresh: 'Refresh',
        your_profile_saved_successfully: 'Your account saved successfully!',
        country_of_id_document: "Country of ID Document",
        id_document_type: 'Type',
        id_number: 'ID Number',
        passport_number: 'Passport number',
        licence_number: 'Licence number',
        expiry_date: 'Expiry date',
        account_info: {
            my_details: 'My details',
            limits: 'Limits',
            rewards: 'Rewards',
            verification: 'Verification',
            security: 'Security'
        },
        id_document_type_labels: {
            driver_licence: 'Driver licence',
            passport: 'Passport',
            identification_card: 'Identification card'
        },
        id_document_types: {
            whats_your_id_document: 'What\'s your ID document?',
            new_zealand_drivers_licence: 'New Zealand Driver\'s Licence',
            new_zealand_passport: 'New Zealand Passport',
            australian_drivers_licence: 'Australian Driver\'s Licence',
            australian_passport: 'Australian Passport',
            other: 'Other'
        },
        additional_documents: 'ADDITIONAL DOCUMENTS',
        when_required_attach_all_files_to_send_your_supporting_documents: 'When required, attach all files to send your supporting documents.',
        verify_email: 'VERIFY EMAIL',
        needs_action: 'Needs action',
        check_your_email_now_to_verify_your_email_address: 'Check your email now to verify your email address.',
        if_you_haven_t_received_any_emails: 'If you haven\'t received any emails, double-check your email address below and send yourself a new verification email',
        change: 'Change',
        send_verification_email: 'SEND VERIFICATION EMAIL',
        check_your_email: 'Check Your Email',
        if_you_didn_t_receive_any_emails: 'If you didn\'t receive any emails',
        wait_for_some_minutes: 'Wait for 5 minutes.',
        double_check_your_email_address_for_spelling_mistakes: 'Double-check your email address for spelling mistakes.',
        check_your_spam: 'Check your Spam.',
        you_can_try_again_after_60_seconds: 'You can try again after 60 seconds.',
        please_check_your_email_and_click_on_verify_email_link: 'Please check your email and click on \'Verify email\' link.',
        your_email_has_been_updated_successfully: 'Your email has been updated successfully!',
        begin_verification: 'Begin verification',
        text_me_now: 'Text me now',
        starting_process: 'Starting...',
        email_verified: 'Email Verified',
        personal_info: 'Personal info',
        verify_identity_address: 'VERIFY IDENTITY & ADDRESS',
        oops_your_identification_result_is_failed: 'Oops! your identification result is failed.',
        i_live_in: 'I live in',
        account_type: 'Account type',
        address: 'Address',
        personal: 'Personal',
        business: 'Business',
        verification_method: 'Verification method',
        manual: 'Manual',
        automatic: 'Automatic',
        for_business_accounts_please_fill_in: 'For Business accounts please fill in the {form}',
        rebit_business_account_form: 'Rebit Business Account form',
        we_ll_update_your_verification_status_accordingly: 'We\'ll update your verification status accordingly.',
        information_submitted: 'Information submitted',
        select_new_zealand_or_australia_for_nz_and_aus_driver_s_licence_or_passport: 'Select New Zealand or Australia for NZ and AUS Driver\'s Licence or Passport.',
        select_iran_if_you_re_sending_an_iranian_passport_as_your_id_document: 'Select Iran if you\'re sending an Iranian passport as your ID document.',
        click_on_the_link_in_your_txt_to_complete_your_verification: 'Click on the link in your TXT to complete your verification.',
        prepare_your_id_document: 'Prepare your ID document.',
        if_this_method_didn_t_work_for_you_please_send_your_details_documents_via_the_manual_method: 'If this method didn\'t work for you, please send your details/documents via the Manual method.',
        we_already_sent_you_a_text_message_with_a_link_click_on_the_link_in_your_sms_to_start: 'We already sent you a text message with a link. Click on the link in your SMS to start.',
        once_done_with_aply_id_don_t_forget_to_come_back_and_refresh_to_see_the_results_here: 'Once done with AplyID, don\'t forget to come back and refresh to see the results here!',
        if_you_didn_t_get_an_sms_you_can_try_again_after_2_minutes: 'If you didn\'t get an SMS you can try again after 2 minutes.',
        sms_sent: 'SMS Sent',
        id_verified_successfully: 'ID & address verified successfully',
        send_money: 'Send money',
        under_review: 'Under review…',
        action_required: 'Action required!',
        we_are_working_on_it: 'We are working on it!',
        thanks_for_starting_your_verification_process: 'Thanks for starting your verification process!',
        we_are_verifying_your_details_and_will_get_back_to_you_asap_meanwhile: 'We are verifying your details and will get back to you ASAP. Meanwhile, keep an eye on your Inbox/Spam',
        we_ll_confirm_your_verification_via_email: 'We\'ll confirm your verification via email.',
        or_we_may_ask_you_to_upload_the_missing_files_here: 'Or we may ask you to upload the missing files here.',
        contact_us: 'Contact us',
        help_and_support: 'Help & support',
        share_rebit_earn_cash: 'Share Rebit, earn cash!',
        share_rebit_earn_money: 'Share Rebit, earn {money}!',
        share_your_reward_link: 'Share your Reward Link',
        your_friend_must_use_your_link_to_sign_up: 'Your friend must use your link to sign up.',
        sign_up_using_this_link_to_receive_rewards: 'Sign up using this link to receive Rewards!',
        you_ll_receive_a_n_reward: 'You\'ll receive a {n} Reward',
        when_they_send_n_currency_or_more_within_30_days: 'when they send {n} {currency} or more, within 30 days.',
        they_ll_also_receive_a_n_currency_reward: 'They\'ll also receive a {n} {currency} Reward',
        terms_conditions_apply: 'Terms & Conditions Apply',
        don_t_miss_out_on_your_referral_reward: 'Don\'t miss out on your referral Reward!',
        verify_to_redeem: 'VERIFY TO REDEEM',
        your_reward_expires_in_remaining_days_day: 'Your Reward expires in {days} day{s}',
        complete_verification_to_generate_your_reward_link: '{complete_verification} to generate your Reward link.',
        complete_verification: 'Complete verification',
        rewards_summary: 'Rewards Summary',
        reward_link: 'Reward Link',
        rewarded_user: 'User',
        rewarded_users: 'Users',
        joined_friends: 'Joined friends',
        cash_earned: 'Cash earned',
        savings_to_date: 'Savings to date',
        unused_rewards: 'Unused Rewards',
        how_it_works: 'HOW IT WORKS',
        number_of_users_joined_via_your_link: 'Number of users joined via your link.',
        total_rewards_earned_to_date_you_only_earn_rewards: 'Total Rewards earned to date. You only earn Rewards when the invited user sends a minimum amount within 30 days of their registration.',
        you_earn_rewards_in_the_currency_of_your_residential_country: 'You earn Rewards in the currency of your residential country. You may redeem your Rewards when you send money and your paying currency is the same.',
        the_discounts_you_received_on_your_previous_orders_due_to_the_rewards_earned: 'The discounts you received on your previous orders due to the Rewards earned.',
        your_balance_to_be_redeemed_in_future_orders: 'Your balance to be redeemed in future orders.',
        we_will_show_your_personal_details_here_once_you_completed_your: 'We will show your personal details here once you completed your {verification}',
        verification: 'VERIFICATION',
        email_notifications: 'Email notifications',
        mobile_notifications: 'Mobile notifications',
        important_order_updates: 'Important order updates',
        essential_emails_related_to_your_order_status: 'Essential emails related to your order status',
        reminders: 'Reminders',
        optional_account_updates_and_key_dates: 'Account updates and key dates',
        ideal_exchange_rates: 'Ideal exchange rates',
        optional_market_updates_based_on_your_preferred_routes: 'Market updates based on your preferred routes',
        announcements_special_offers: 'Announcements & special offers',
        optional_rebit_feature_updates_and_great_deals: 'Rebit feature updates and great deals',
        financial_news: 'Financial NEWS',
        optional_local_highlights_tailored_for_you: 'Local highlights tailored for you',
        notify_important_messages_via_whats_app: 'Notify important messages via WhatsApp',
        notify_important_messages_via_telegram: 'Notify important messages via Telegram',
        transfer_limits: 'Transfer Limits',
        monthly_transfer_limits: 'Monthly Transfer Limits',
        send_supporting_documents_to_increase_your_limits: 'Send supporting documents to increase your limits.',
        send_documents: 'Send Documents',
        limits_faq: 'Limits FAQ',
        do_you_still_live_here: 'Do you still live here?',
        update_information: 'Update Information',
        yes_i_live_at: 'Yes, I live at {address}...',
        no_that_s_my_old_address: 'No, that\'s my old address',
        edit_details: 'Edit details',
        new_address: 'New address',
        upload_new_address_proof: 'Upload new address proof',
        send_money_reasons: {
            how_will_you_use_rebit: 'How will you use Rebit?',
            how_will_user_use_rebit: 'How will user use Rebit?',
            choose_all_reasons_for_transfer_that_apply: 'Choose all reasons for transfer that apply.',
            how_often_will_you_use_rebit_to_send_money: 'How often will you use Rebit to send money?',
            how_much_do_you_usually_send_per_transfer: 'How much do you usually send per transfer?',
            how_often_options: {
                choose_frequency: 'Choose frequency',
                every_month: 'Every month',
                every_3_6_months: 'Every 3-6 months',
                every_year: 'Every year',
            },
            how_much_options: {
                select_a_range: 'Select a range',
                up_to_1000: 'Up to 1000 USD',
                _1000_5000_ :'1,000 – 5,000 USD',
                over_5000: 'Over 5,000 USD'
            },
            save_reasons_successfully_message: 'Thanks! Your transfer reasons have been saved.'
        },
    },
}
